export default __webpack_public_path__ + "static/2-search-result-5e42e68a054fdab93e806ac6146dbbd0.jpg";